import { LoadingSkeleton } from '@/components/LoadingSkeleton/LoadingSkeleton'
import clsx from 'clsx'

type HtmlReferenceLoadingSkeletonProps = {
  className?: string
}

function HtmlReferenceSkeletonParagraph() {
  return (
    <div className="flex flex-col gap-2">
      <LoadingSkeleton width={134} lineHeight={16} />
      {Array.from({ length: 7 }).map((_, index) => (
        <LoadingSkeleton key={index} width="100%" lineHeight={16} />
      ))}
    </div>
  )
}

export function HtmlReferenceLoadingSkeleton({ className }: HtmlReferenceLoadingSkeletonProps) {
  return (
    <div className={clsx('relative h-full flex flex-col items-center p-3 animate-fadeIn', className)}>
      <div className="view-container flex flex-col gap-6 bg-white w-full border border-brand-neutral-200 p-4">
        <div className="flex flex-col gap-2">
          <LoadingSkeleton width={280} lineHeight={16} />
          <LoadingSkeleton width={234} lineHeight={16} />
        </div>
        <HtmlReferenceSkeletonParagraph />
        <HtmlReferenceSkeletonParagraph />
        <HtmlReferenceSkeletonParagraph />
        <HtmlReferenceSkeletonParagraph />
      </div>
    </div>
  )
}
